// Choreography: each song gets its own order of routines (seeded by song id); routine changes every 8 beats.
const ROUTINES = [
  { poses: ["jump", "front"], move: () => ({ y: [0, -38, 0], rotate: 0, x: 0, scale: [1, 1.04, 1] }) },
  { poses: ["sideL", "sideR"], move: (i) => ({ y: [0, -10, 0], rotate: i % 2 ? [0, 12, 0] : [0, -12, 0], x: i % 2 ? [0, 22, 0] : [0, -22, 0], scale: 1 }) },
  { poses: ["front", "sideR", "back", "sideL"], move: () => ({ y: [0, -16, 0], rotate: [0, 6, 0], x: 0, scale: [1, 0.95, 1] }) },
  { poses: ["winkwave", "wave3q"], move: (i) => ({ y: [0, -8, 0], rotate: i % 2 ? [-8, 8] : [8, -8], x: 0, scale: 1 }) },
  { poses: ["star", "heart", "jump", "winkwave"], move: () => ({ y: [0, -22, 0], rotate: 0, x: 0, scale: [1, 1.14, 1] }) },
  { poses: ["jump", "jump", "front", "sideR"], move: (i) => ({ y: i % 4 < 2 ? [0, -48, 0] : [0, -6, 0], rotate: i % 4 < 2 ? [0, -10, 0] : 0, x: 0, scale: 1 }) },
];

const hash = (s = "") => [...String(s)].reduce((h, c) => (h * 31 + c.charCodeAt(0)) >>> 0, 7);

export const routineOrder = (songId) => {
  let seed = hash(songId) || 1;
  const order = ROUTINES.map((_, i) => i);
  for (let i = order.length - 1; i > 0; i -= 1) {
    seed = (seed * 1103515245 + 12345) >>> 0;
    const j = seed % (i + 1);
    [order[i], order[j]] = [order[j], order[i]];
  }
  return order;
};

export const stepFor = (order, beat) => {
  const r = ROUTINES[order[Math.floor(beat / 8) % order.length]];
  return { pose: r.poses[beat % r.poses.length], move: r.move(beat) };
};
